export {
    default
} from './route.config';
const _import =  require('../_import_' + process.env.NODE_ENV)

// 用户模块
export const AuthIndex = _import('Auth/App');
export const UserLogin = _import('Auth/Login'); //_import('Auth/login/index');
export const UserRegister = _import('Auth/Register');
export const UserRegisterOrg = _import('Auth/RegisterOrg');
export const UserVerifyMobile = _import('Auth/verifyMobile');
export const UserForgetpwd = _import('Auth/Forgetpwd');
export const UserIndex = _import('Auth/Index');
export const UserSchoolRegister = _import('Auth/SchoolRegister');



// WEBPACK FOOTER //
// ./src/views/Auth/index.js